import { z } from "zod";

export const SearchQuery = z.object({
  q: z.string().min(1).max(200),
  limit: z.coerce.number().int().min(1).max(50).default(5),
});

export interface SearchHit {
  type: "company" | "facility" | "plant" | "person" | "master_ingredient" | "company_ingredient" | "product" | "inspection" | "production" | "comment";
  id: string;
  title: string;
  subtitle?: string;
  status?: string;
  href: string;
}

export interface SearchGroup {
  type: SearchHit["type"];
  label: string;
  hits: SearchHit[];
  more: boolean;
}
